export class TEMPLATES {
  static readonly menu = 1;
  static readonly referenceData = 2;
  static readonly referenceDataList = 3;
  static readonly approverCoiForm = 4;
  static readonly coiFormList = 5;
  static readonly coiForm = 6;
  static readonly dopiFormList = 7;
  static readonly dopiForm = 8;
  static readonly gbhFormList = 9;
  static readonly gbhForm = 10;
  static readonly approverGbhForm = 11;
  static readonly approverDopiForm = 12;
  static readonly integrityOfficerList = 13;
  static readonly integrityOfficer = 14;
};

export class VERSIONS {
  static readonly latest = 0;
}

export class TEMPLATE_NAMES {
}
